import { datatype, lorem, random } from "faker/locale/en_US";

import { defaultTaskTypes } from "../../../root/defaultConfiguration";
import type { Task } from "../../../types";
import type { Db } from "./types";
import { randomDate } from "./utils";

export const type: string[] = [
  "email",
  "email",
  "email",
  "email",
  "email",
  "email",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "call",
  "demo",
  "lunch",
  "meeting",
  "follow-up",
  "follow-up",
  "thank-you",
  "ship",
  "none",
];

export const generateTasks = (db: Db, size = 3) => {
  const priorities: ("baixa" | "media" | "alta")[] = ["baixa", "media", "alta"];
  return Array.from(Array(size).keys()).map<Task>((id) => {
    const contact = db.contacts[id % db.contacts.length] || db.contacts[0];
    const deal = db.deals[id % db.deals.length] || db.deals[0];
    const company =
      db.companies.find((c) => c.id === contact?.company_id) || db.companies[0];

    contact.nb_tasks = (contact.nb_tasks ?? 0) + 1;
    const dueDate = randomDate(
      new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      new Date(Date.now() + 14 * 24 * 60 * 60 * 1000),
    );
    const endDate = new Date(dueDate.getTime() + 60 * 60 * 1000);

    return {
      id,
      contact_id: contact.id,
      deal_id: deal ? deal.id : undefined,
      company_id: company ? company.id : undefined,
      type: random.arrayElement(defaultTaskTypes).value,
      text: lorem.sentence(),
      due_date: dueDate.toISOString(),
      data_inicio: dueDate.toISOString(),
      data_fim: endDate.toISOString(),
      prioridade: random.arrayElement(priorities),
      link_chamada: datatype.boolean()
        ? "https://meet.google.com/xyz-crm-dotus"
        : undefined,
      done_date: datatype.boolean() ? dueDate.toISOString() : undefined,
      sales_id: 0,
    };
  });
};
